import './css/App.css';
import 'video.js/dist/video-js.min.css';
import 'jquery-ui-dist/jquery-ui.min.css';

import CampaignController from './controllers/campaign';

window.SDK_ARTEMIS_KEY = '_SDK_ARTEMIS_KEY_';
window.SDK_ARTEMIS_VERSION = '_SDK_ARTEMIS_VERSION_';

class App {
  campaignController;

  constructor() {
    this.campaignController = new CampaignController();
  }

  loadCampaign = async (
    zoneUuid,
    userId,
    context,
    cb,
    urlAdserver = undefined
  ) => {
    return this.campaignController.loadCampaign(
      zoneUuid,
      userId,
      context,
      cb,
      urlAdserver
    );
  };

  loadCampaign = async (
    zoneUuid,
    userId,
    context,
    cb,
    urlAdserver = undefined,
    source = undefined
  ) => {
    return this.campaignController.loadCampaign(
      zoneUuid,
      userId,
      context,
      cb,
      urlAdserver,
      source
    );
  };

  loadCampaignCode = async (code, cb, urlAdserver = undefined) => {
    return this.campaignController.loadCampaignCode(code, cb, urlAdserver);
  };

  changeColors = (colors) => {
    this.campaignController.changeColors(colors);
  };

  renderCampaign = (content, cb, cbGiveBenefit = null, modeEmbedded = null) => {
    return this.renderCampaignCustom({
      content,
      cb,
      cbGiveBenefit,
      modeEmbedded,
    });
  };

  renderCampaignCustom = (renderParams) => {
    return this.campaignController.renderCampaign(renderParams);
  };
}

export default App;
